module.exports = __webpack_public_path__ + "static/brand-logo-19159c684d2400171b9d3a85e28b5de3.svg";